import { render } from "./App.vue?vue&type=template&id=11bbd848"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=11bbd848&lang=css"

import exportComponent from "C:\\Users\\86198\\WebstormProjects\\rustedcreateronline\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__